import axios from 'axios'

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL
})


export const errorHandle = (err) => {
    if (err.response) {
        return err.response.data
    } else if (err.request) {
        // console.log('error request')
        // console.log(err.request)
        return {
            message: 'ไม่สามารถเชื่อมต่อเซิฟเวอร์ได้',
            err_message: 'The request was made but no response was received'
        }
    } else {
        // console.log('error message')
        // console.log(err.message)
        return { message: err.message }
    }
}

export const authenHeader = (token) => {
    return { "authorization": `bearer ${token}` }
}

export const formDataHeader = {
    "Content-Type": "multipart/form-data"
}

export const APIURL = {
    OFFICE: '/master/office',
    LEVEL: '/master/level',
    ROLE: '/master/role',
    LOCATION: '/master/location',
    RESIDENCE: '/master/residence',
    DOCUMENT: '/master/document',
    FORM_STATUS: '/master/formstatus',
    QUEUE_GROUP: '/master/queuegroup',
    DASHBOARD_STAT: '/stat/dashboard',
    REGISTER: '/auth/register',
    LOGIN: '/auth/login',
    USER: (uid) => `/user/${uid || ''}`,
    FORM_REQUEST: (fid) => `/form_request/${fid || ''}`,
    QUEUE_RESIDENCE: (query) => `/queue/residence/${query || ''}`, // /queue/residence/:rid?query&...
    QUEUE_FULLNAME: (query) => `/queue/name${query || ''}`, // /queue/name?query&...
    QUEUE_OWNER: (uid) => `/queue/?owner_uid=${uid || ''}`,
    QUEUE_NAME: (name) => `/queue/?name=${name || ''}`,
    QUEUE_DISCLIAM: (id) => `/queue/discliam/${id || ''}`,
    QUEUE: (qid) => `/queue/${qid || ''}`,
    EMAIL: (eid) => `/email/${eid || ''}`,
    CONTRACT: (query) => `/contract/${query || ''}`, // /contract/:id?query&... , /contract/me?query&...
}

export default instance